import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';

zxcvbnOptions.setOptions({
  dictionary: { ...zxcvbnCommonPackage.dictionary },
  graphs: zxcvbnCommonPackage.adjacencyGraphs
});

export type PasswordScore = 0 | 1 | 2 | 3 | 4;

export const PASSWORD_SCORE_LABELS: readonly string[] = [
  'Very weak',
  'Weak',
  'Fair',
  'Good',
  'Strong'
];

// zxcvbn convention: score 2 = Fair, score 3 = Good. The sign-up help text
// says "Submit unlocks at 'Fair' or stronger" — so the gate is score ≥ 2.
// (web-mock/features/sign-up/prd.md §"Password" reads "≥ 'fair' (3)" which
// is internally inconsistent with the conventional label table; resolved
// here in favor of the user-visible help-text wording.)
export const PASSWORD_MIN_SCORE: PasswordScore = 2;
export const PASSWORD_MIN_LENGTH = 8;

export function scorePassword(value: string): PasswordScore {
  if (!value) return 0;
  return zxcvbn(value).score as PasswordScore;
}

export function passwordPasses(value: string): boolean {
  return value.length >= PASSWORD_MIN_LENGTH && scorePassword(value) >= PASSWORD_MIN_SCORE;
}
